<template>
	<v-menu offset-y>
		<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
					<v-btn
						icon
						dark
						small
						color="#959595"
						v-bind="{ ...tooltipAttrs, ...menuAttrs }"
						v-on="{ ...tooltipOn, ...menuOn }"
					>
						<v-icon small>mdi-briefcase-clock-outline</v-icon>
					</v-btn>
				</template>
				<span>Historial del {{ textContract }}</span>
			</v-tooltip>
		</template>
		<v-list dense class="py-0 white">
			<v-list-item dense class="mb-0" style="min-height: 25px; background: #959595;">
				<div>
					<p class="caption mb-0 font-weight-bold white--text">Historial del {{ textContract }}</p>
				</div>
			</v-list-item>
			<v-list-item dense class="my-0 py-0" style="min-height: 25px;">
				<div class="d-flex align-center flex-grow-1">
					<p class="caption mb-0 text--disabled" style="width: 160px;">Estado</p>
					<p class="caption mb-0 text--disabled" style="width: 120px;">Fecha</p>
					<p class="caption mb-0 text--disabled" style="width: 70px;">Acción</p>
				</div>
			</v-list-item>
			<v-divider></v-divider>
			<v-list-item-group color="#524D4D" style="max-height: 350px;overflow-y:scroll;">
				<v-list-item
					v-for="(contractStatus, index) in contract.statuses"
					:key="'ctstatus-'+index"
					dense
					style="min-width: 380px;"
					class="white"
				>
					<v-list-item-title dense>
						<div class="d-flex align-center item-background-hover">
							<div class="d-flex align-center caption" style="width: 160px;">
								<v-icon class="mr-1" x-small :color="contractStatusColor(contractStatus.status)">mdi-circle</v-icon>
								<b>{{ getContractStatusText(contractStatus.status) }}</b>
							</div>
							<div class="d-flex align-center caption" style="width: 120px;">
								<p class="mb-0 caption text-end">{{contractStatus.created_at | toDateTime}}</p>
							</div>
							<div class="d-flex align-center caption" style="width: 70px;">
								<v-btn
									v-if="contractStatus.pdf"
									text
									x-small
									@click="openPdf(contractStatus.pdf.file)"
								>
									<p class="mb-0 caption">Ver PDF</p>
								</v-btn>
								<p v-else class="mb-0 caption text--disabled">--</p>
							</div>
						</div>
					</v-list-item-title>
				</v-list-item>
			</v-list-item-group>
		</v-list>
	</v-menu>
</template>

<script>
export default {
  name: 'ContractPdfHistory',
  components: { },
	props: {
		contract: {
			type: Object,
			required: true
		},
		isSubcontract: {
			type: Boolean,
			default: false
		},
		contractStatuses: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		contractType() {
			if (this.contract?.addendum_to_contract_id) {
				return 'addendum'
			}
			if (this.contract?.subcontract_to_contract_id) {
				return 'subcontract'
			}
			return 'contract'
		},
		textContract() {
			if(this.contract.addendum_to_contract_id){
				return 'Anexo'
			}
			if(this.contract.subcontract_to_contract_id){
				return 'Subcontrato'
			}
			return 'Contrato'
		}
	},
  data: () => ({
    validform: true,
	}),
  methods: {
		openPdf(file) {
			// this.$store.commit('contracts/setContractPdfModal', {...contract, ...{forced_pdf: contractStatus.pdf}})

			const screenWidth = window.screen.width;
			const screenHeight = window.screen.height;
			const finalWidth = Math.min(1000, screenWidth);

			window.open(
				`${file.file_link}`,
				'',
				`width=${finalWidth},height=${screenHeight},left=${finalWidth},top=0,toolbar=no,menubar=no,location=no,status=no`
			);
		},
		contractStatusColor(status) {
			return this.$options.filters?.contractStatusColor?.(status) || '#000'
		},
		getContractStatusText(status) {
			if (this.isSubcontract) {
				return this.$options.filters?.contractStatusSubcontractor?.(status) || '--'
			}
			return this.$options.filters?.contractStatus?.(status) || '--'
		},
	}
};
</script>